function toFaDigits(value) {
  return String(value).replace(/\d/g, (digit) => "۰۱۲۳۴۵۶۷۸۹"[digit] || digit);
}

/** Persian calendar as Day/Month/Year with Persian digits, e.g. ۱۴/۰۵/۱۴۰۵ */
export function formatDateFa(iso) {
  if (!iso) return "—";
  const d = String(iso).slice(0, 10);
  try {
    const parts = new Intl.DateTimeFormat("fa-AF-u-ca-persian", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(new Date(`${d}T12:00:00`));
    const get = (type) => parts.find((p) => p.type === type)?.value || "";
    return toFaDigits(`${get("day")}/${get("month")}/${get("year")}`);
  } catch (_e) {
    return d;
  }
}

function todayIsoLocal() {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

function normalizeIso(value) {
  if (!value) return "";
  return String(value).slice(0, 10);
}

/**
 * Resolve printable titles from semester / date filters.
 * - semester only → semester name
 * - today only → معاش امروز (+ semester)
 * - custom range → date(s) — semester
 */
export function getDailySalaryReportLabels({
  yearLabel,
  from,
  to,
} = {}) {
  const semester = yearLabel || "تمام سمسترها";
  const fromDate = normalizeIso(from);
  const toDate = normalizeIso(to);
  const today = todayIsoLocal();
  const hasDateFilter = Boolean(fromDate || toDate);
  const effectiveFrom = fromDate || toDate;
  const effectiveTo = toDate || fromDate;
  const isTodayOnly =
    hasDateFilter &&
    effectiveFrom === today &&
    effectiveTo === today;

  if (!hasDateFilter) {
    return {
      scope: "semester",
      headerSubtitle: semester,
      tableTitle: `گزارش معاش ${semester}`,
      excelTitle: `گزارش معاش — ${semester}`,
    };
  }

  if (isTodayOnly) {
    return {
      scope: "today",
      headerSubtitle: `معاش امروز — ${semester}`,
      tableTitle: "معاش امروز",
      excelTitle: `معاش امروز — ${semester}`,
    };
  }

  const fromFa = formatDateFa(effectiveFrom);
  const toFa = formatDateFa(effectiveTo);
  const datePart =
    effectiveFrom === effectiveTo ? fromFa : `${fromFa} – ${toFa}`;

  return {
    scope: "custom",
    headerSubtitle: `${datePart} — ${semester}`,
    tableTitle: `گزارش معاش ${datePart}`,
    excelTitle: `گزارش معاش ${datePart} — ${semester}`,
  };
}
